import { create } from "../../../common/utils/zustand_state_manager";
import { IProjetosRepository } from "../../../features/projetos/domain/repositories/projetos_repository";
import { useProjetosServices } from "./use_services";
import { ProjetosRepository } from "../../../features/projetos/data/repositories/projetos_repository";

/**
 * useObrasRepositories
 */

type State = {
  projetosRepository: IProjetosRepository;
};

export const useProjetosRepositories = create<State>((set, get) => {
  const { projetosService } = useProjetosServices.getState();
  return {
    projetosRepository: new ProjetosRepository(projetosService),
  };
});
